import { Route } from '@angular/router';
import { LoginComponent } from './ui/login/login.component';

const authRoutes: Route[] = [
  {
    path: '',
    children: [
      {
        path: '',
        component: LoginComponent,
      },
      {
        path: 'login-failed',
        component: LoginComponent,
      },
    ],
  },
];

export default authRoutes;
